// src/components/Spinner.js
import React from 'react';
import './Spinner.css';

const Spinner = ({ message, inline = false, size = 'default' }) => {
  // If inline is true, render just the spinner icon without the overlay container
  if (inline) {
    return (
      <div className={`spinner-inline ${size}`}>
        <div className="spinner"></div>
        {message && <span className="spinner-message-inline">{message}</span>}
      </div>
    );
  }

  // Default behavior: Full screen blocking overlay
  return (
    <div className="spinner-overlay">
      <div className="spinner"></div>
      {message && <div className="spinner-message">{message}</div>}
    </div>
  );
};

export default Spinner;
